export default "__VITE_ASSET__DssNVCeI__"